type NumericEnumDefinition = Record<string, number>

type StringEnumDefinition = Record<string, string>

type ForwardMap<DEFINITION extends NumericEnumDefinition | StringEnumDefinition> = {
  readonly [KEY in keyof DEFINITION]: Readonly<DEFINITION[KEY]>
}

type KeyFromVal<RECORD, VALUE> = {
  [KEY in keyof RECORD]: VALUE extends RECORD[KEY] ? KEY : never
}[keyof RECORD]

declare const __w__: unique symbol

type NumericEnum<DEFINITION extends NumericEnumDefinition> = ForwardMap<DEFINITION> & {
  [__w__]: DEFINITION
}

type StringEnum<DEFINITION extends StringEnumDefinition> = ForwardMap<DEFINITION> & {
  [__w__]: DEFINITION
}

type Enum = NumericEnum<any> | StringEnum<any>

/**
 * @deprecated this utility is used to replace typescript `enum` (should be
 * avoided). Instead of `enum`, new code should use string unions
 *
 * Create a typescript-like string enum (an enum with string values) at runtime
 */
export function create<TYPE extends number, DEFINITION extends Record<string, TYPE>>(
  definition: DEFINITION,
): NumericEnum<DEFINITION>
/**
 * @deprecated this utility is used to replace typescript `enum` (should be
 * avoided). Instead of `enum`, new code should use string unions
 *
 * Create a typescript-like numeric enum (an enum with numeric values) at runtime
 */
export function create<TYPE extends string, DEFINITION extends Record<string, TYPE>>(
  definition: DEFINITION,
): StringEnum<DEFINITION>
/**
 * @deprecated this utility is used to replace typescript `enum` (should be
 * avoided). Instead of `enum`, new code should use string unions
 *
 * Create a typescript-like enum at runtime
 */
export function create(definition: Record<string, number | string>): Enum {
  const map: Record<string | number, string | number> = Object.create(null)
  for (let [name, value] of Object.entries(definition)) {
    if (typeof value === 'string') {
      map[name] = value
    } else {
      map[value] = name
      map[name] = value
    }
  }

  return map as any
}

/**
 * @deprecated this utility is used to replace typescript `enum` (should be
 * avoided). Instead of `enum`, new code should use string unions
 *
 * Type of a value of the enum (union of all its values)
 */
export type ValueOf<ENUM extends Enum> = ENUM[typeof __w__][keyof ENUM[typeof __w__]]

/**
 * @deprecated this utility is used to replace typescript `enum` (should be
 * avoided). Instead of `enum`, new code should use string unions
 *
 * In typescript numeric enums have a reverse mapping (value => key). This
 * utility gives the reverse mapping of a numeric enum.
 */
export function reverse<ENUM extends NumericEnum<any>>(
  numericEnum: ENUM,
): {
  [VALUE in ValueOf<ENUM>]: KeyFromVal<ENUM[typeof __w__], VALUE>
} {
  return numericEnum
}
